<script lang="ts" setup>
import { format } from 'date-fns';
import { computed } from 'vue';

import GridLines from '@exchange/assets/grid-lines.svg';
import Logo from '@exchange/assets/one-trading-white-logo.svg';
import { capIsNativePlatform, capBrowser } from '@exchange/libs/utils/capacitor/src';
import { launchdarkly } from '@exchange/libs/utils/launchdarkly/src';

const formatDate = (date: string | Date) => format(typeof date === 'string' ? new Date(date) : date, 'dd/MM/yy HH:mm(zzz)');

const timeFrame = launchdarkly.flags['platform-upgrade'];
const from = computed(() => formatDate(timeFrame.value.from));
const to = computed(() => formatDate(timeFrame.value.to));

const contactSupport = () => {
  const supportUrl = 'https://support.onetrading.com/requests/new';

  if (capIsNativePlatform()) {
    capBrowser.open({ url: supportUrl });
  } else {
    window.location.href = supportUrl;
  }
};
</script>

<template>
  <div class="maintenance-page">
    <grid-lines class="maintenance-page__grid-lines"></grid-lines>
    <div class="maintenance-page__blur"></div>
    <div class="maintenance-page__content">
      <div class="maintenance-page__item">
        <logo class="maintenance-page__logo"></logo>
      </div>
      <div class="maintenance-page__item">
        <x-modal
          variant="dark"
          :title="$t('views.maintenance.dialog.title')"
          :can-close="false"
        >
          <template #content>
            <div class="maintenance-page__text maintenance-page__text--main">
              <p>{{ $t('views.maintenance.dialog.textMain', { start: from, end: to }) }}</p>
            </div>
            <div class="maintenance-page__text">
              <p>{{ $t('views.maintenance.dialog.textAddition') }}</p>
            </div>
          </template>
          <template #buttons>
            <x-button
              variant="tertiary"
              :text="$t('views.maintenance.dialog.action')"
              @click="contactSupport"
            />
          </template>
        </x-modal>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.maintenance-page {
  --grid-horizontal-offset: 20%;

  display: grid;
  flex: 1 1 auto;
  background-color: rgb(var(--v-theme-elevation-0));
  grid-template-columns: var(--grid-horizontal-offset) auto var(--grid-horizontal-offset);

  &__content {
    display: flex;
    flex-direction: column;
    margin-top: 15vh;
    gap: 42px;
    grid-column-start: 2;

    .xs & {
      margin-top: 5vh;
      gap: 0;
    }
  }

  &__grid-lines {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  &__blur {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 28%;
    height: 40%;
    border-radius: 317px;
    background: linear-gradient(180deg, #00a3c296 0%, #0e7bf800 86.35%);
    filter: blur(200px);
    transform: translate(-50%, -50%);

    .xs & {
      width: 57%;
      height: 50%;
    }
  }

  &__item {
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }

  &__logo {
    width: 320px;
    height: 112px;

    .xs & {
      width: 220px;
    }
  }

  &__text p {
    margin: 0;
    font-size: var(--font-size-md);
  }

  &__text--main {
    padding-bottom: 20px;
  }
}
</style>
